import { Rate } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const DynamicFieldInputRate = ({ value, onChange, ...props }) => {
  return <Rate value={value} onChange={onChange} allowHalf {...props} />;
};

DynamicFieldInputRate.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default memo(DynamicFieldInputRate);
